module.exports = __webpack_public_path__ + "static/Sébastien-685f01fca73b45331dbcf341c52e1596.png";